import React from "react";
import SampleTeachingState, { SampleTeachingProps } from "./SampleTeaching.models";
import './SampleTeaching.scss';
import ProductAuthorService from "../../../services/content/ProductAuthorService";
import SampleTeachingImage from '../../../assest/images/card-image/ItemAvata.png';
import NotFoundDataInDate from "../../shared/not-found-data-in-date/NotFoundDataInDate";
import VideoThumbnails from "../../shared/react-thumbnail/thumbnail"
import NonBackGroundModal from "../../shared/non-background-modal/NonBackGroundModal";

export default class SampleTeaching extends React.PureComponent<SampleTeachingProps, SampleTeachingState>{

    productAuthorService: ProductAuthorService;
    constructor(props: any) {
        super(props);
        this.productAuthorService = new ProductAuthorService();
        this.state = { sampleTeachingList: [], selectedUrlVideo: '', showModal: false };
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.authorId !== prevProps.authorId)
            this.getData();
    }

    getData() {
        let self = this;
        let props = this.props;

        if (props.authorId !== null && props.authorId !== undefined)
            self.productAuthorService.getSampleTeachesByAuthorId(props.authorId).then(function (response) {
                self.setState({ sampleTeachingList: response.sampleTeaches });
            });
        else
            self.productAuthorService.getSampleTeachesList({
                orderField: "id",
                pageSize: 1000,
                pageSkip: 0,
                descendingOrder: true
            }).then(function (response) {
                self.setState({ sampleTeachingList: response });
            });

    }

    modalHandler = (openModal: boolean, videoUrl: string) => {
        this.setState({ selectedUrlVideo: videoUrl, showModal: openModal })
    }

    render(): React.ReactNode {
        let { sampleTeachingList } = this.state;
        let content;
        if (sampleTeachingList.length > 0) {
            content = (<>
                {sampleTeachingList.map((sampleTeach, key) => {
                    return <div key={key} className="col-12 notspace">
                        <div className="tk-card tk-padding-bottom">
                            <div className="card-icon">
                                <img src={SampleTeachingImage} alt="sample teaching icon" />
                            </div>
                            <div className="card-title">
                                <label>{sampleTeach.title}</label>
                            </div>
                            <div className="tk-row-video" onClick={() => this.modalHandler(true, sampleTeach.videoAttachmentId)}>
                                {/* <video width="320" height="185" controls>
                                    <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${sampleTeach.videoAttachmentId}`} type="video/mp4" />
                                </video> */}
                                <VideoThumbnails videoUrl={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${sampleTeach.videoAttachmentId}`} />
                            </div>
                            <div className="col-12 card-info">
                                <label>
                                    {sampleTeach.description}
                                </label>
                            </div>
                        </div>
                    </div>
                })}

            </>);
        }
        else {
            content = (<>
                <NotFoundDataInDate title="موردی یافت نشد" />
            </>);
        }
        return (<>

            <div className="dropdown-list sample-teaching-area" style={{ height: this.props.height ? this.props.height : "65vh", paddingBottom: "70px" }}>
                {content}
            </div>
            <NonBackGroundModal showModal={this.state.showModal} hasVideo={true} onClose={() => this.modalHandler(false, '')} attachmentId={this.state.selectedUrlVideo} />
        </>);
    }
}